<template>
  <div class="thinking">

    <corner-item
      :images="images"
      :corner="a"
      :i="0">
    </corner-item>

    <corner-item
      :images="images"
      :corner="b"
      :i="1">
    </corner-item>

    <corner-item
      :images="images"
      :corner="c"
      :i="2">
    </corner-item>

    <corner-item
      :images="images"
      :corner="d"
      :i="3">
    </corner-item>

    <!-- <div class="thinking-circle">
      <span class="thinking-text">Thinking
        <span class="ellipsis"></span>
        <span class="ellipsis"></span>
        <span class="ellipsis"></span>
      </span>
    </div> -->
  </div>
</template>

<script>
import CornerItem from './CornerItem'

import anime from 'animejs'

  export default {
    props: {
      frame: {
        type: String,
        required: true
      },
    },
    mounted() {
      let images = this.images;
      let currentImages = this.currentImages;

      // anime({
      //   targets: '.thinking-text .ellipsis',
      //   delay: function(el, i) {
      //     return 100 * i + 300;
      //   },
      //   duration: 600,
      //   translateY: [0, "-6px", 0],
      //   easing: 'easeInOutQuad',
      //   // direction: 'alternate',
      //   loop: true
      // })
    },
    components: {
      CornerItem
    },
    data() {
      return {
        images: [
          {
            img: "/static/calque.png",
            color: "#91cbb7"
          }, {
            img: "/static/hydra-essential.png",
            color: "#2baade"
          }, {
            img: "/static/mission-perfection.png",
            color: "#f69783"
          }, {
            img: "/static/double-serum-cap.png",
            color: "#fbb161"
          }
        ],
        a: {
          img: "/static/calque.png",
          color: "#91cbb7"
        },
        b: {
          img: "/static/hydra-essential.png",
          color: "#2baade"
        },
        c: {
          img: "/static/mission-perfection.png",
          color: "#f69783"
        },
        d: {
          img: "/static/double-serum-cap.png",
          color: "#fbb161"
        },
        movingEllipsis: "..."
      }
    },
    methods: {
    }
  }
</script>

<style lang="scss">
.thinking {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;

  z-index: 100;

  img {
    // width: 100%;
    // max-width: 250px;
    // height: 100%;
    width: 84%;
    max-width: 217px;
    height: auto;
    // object-fit: cover;
    // object-position: top;
  }

  > * {
    overflow: hidden;
  }

  background-color: #fff;
}

.corner-0 {
  position: absolute;
  width: 50%;
  height: 50%;
  left: 0;
  top: 0;
  img {
    position: absolute;
    bottom: 0%;
    left: 50%;
    transform: translateX(-50%) translateY(50%);
  }
}
.corner-1 {
  position: absolute;
  width: 50%;
  height: 50%;
  left: 50%;
  top: 0;
  img {
    position: absolute;
    bottom: 0%;
    left: 50%;
    transform: translateX(-50%) translateY(50%);
  }
}
.corner-2 {
  position: absolute;
  width: 50%;
  height: 50%;
  left: 0;
  top: 50%;
  img {
    position: absolute;
    top: 0%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    object-position: bottom;
  }
}
.corner-3 {
  position: absolute;
  width: 50%;
  height: 50%;
  left: 50%;
  top: 50%;
  img {
    position: absolute;
    top: 0%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    object-position: center bottom;
  }
}

.thinking-circle {
  position: absolute;
  z-index: 5;

  background-color: #fff;

  width: 50%;
  padding-top: 50%;
  border-radius: 50%;

  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);

  .thinking-text {
    display: flex;
    align-items: baseline;
    position: absolute;
    color: black;

    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);

    .ellipsis {
      width: 4px;
      height: 4px;
      border-radius: 50%;
      margin-left: 3px;

      background-color: #000;
      display: block;
    }
  }
}
</style>